<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import {numeric, required} from "vuelidate/lib/validators";
import appConfig from "@/app.config.json";
import {notifyModel} from "@/models/notifyModel";
import vue2Dropzone from "vue2-dropzone";
import {thongTinTrangModel} from "@/models/thongTinTrangModel";
import Switches from "vue-switches";

export default {
  page: {
    title: "THÔNG TIN TRANG",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {Layout, PageHeader },
  data() {
    return {
      data: [],
      title: "THÔNG TIN TRANG",
      items: [
        {
          text: "THÔNG TIN TRANG",
          active: true,
        }
      ],
      model: thongTinTrangModel.baseJson(),
      showModal : false,
      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_URL}files/upload`,
        thumbnailWidth: 300,
        thumbnailHeight: 160,
        maxFiles: 4,
        maxFilesize: 30,
        headers: { "My-Awesome-Header": "header value" },
        addRemoveLinks: true,
        acceptedFiles: ".pdf",
      },
      url :  process.env.VUE_APP_API_URL + 'files/view/' ,
      submitted: false,
    };
  },
  computed: {
    //Validations
    rules(){
      return{
        name:{required},
        donVi: {required},
        diaChi: {required},
        soDienThoai: {required},
      }
    }
  },
  validations: {
    model: {
      name:{required},
      donVi: {required},
      diaChi: {required},
      soDienThoai: {required},
    },
  },
  created() {
    this.getThongTin()
  },
  methods: {
    async handleSubmitThongTin(e) {
      console.log("LOG THONG TIN ", this.model)
      e.preventDefault();
      this.submitted = true;
      this.$v.$touch();
      console.log("LOG INVALID 36165 : ", this.$v);
      if (this.$v.$invalid) {
        console.log("LOG INVALID  : ")
        return;
      } else {
        console.log("LOG ELSE  INVALID  : ")
        let loader = this.$loading.show({
          container: this.$refs.formContainer,
        });
      await this.$store.dispatch("thongtinTrangStore/create", this.model).then((res) => {
        if (res.code === 0) {
          this.model = res.data
          this.showModal = false;
        }
        this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res))
      });
        loader.hide();
        this.submitted = false;

    }
    this.submitted = false;
},

    async getThongTin(){
      let promise =  this.$store.dispatch("thongtinTrangStore/getAll")
      return promise.then(resp => {
           this.model = resp.data
      })
    },

  },
  watch: {},
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>

    <div class="card">
      <div class="card-body table-size">
        <form ref="formContainer">
          <!-- API Key -->
          <div class="row">
            <div class="col-md-3">
              <label for="">Tên trang web </label><span class="text-danger">*</span>
            </div>
            <div class="col-md-9">
              <div class="form-group mb-3">
                <input
                    v-model="model.name"
                    type="text"
                    class="form-control"
                    placeholder="Nhập tên trang web"
                    :class="{
                      'is-invalid':
                        submitted && $v.model.name.$error,
                    }"
                >
                <div
                  v-if="submitted && !$v.model.name.required"
                    class="invalid-feedback"
                >
                  Tên trang Web không được trống.
                </div>
              </div>
            </div>
          </div>
          <!--Is Ative -->



          <div class="row">
            <div class="col-md-3">
              <label for="">Tên đơn vị quản lý </label><span class="text-danger">*</span>
            </div>
            <div class="col-md-9">
              <div class="form-group mb-3">
                <input
                    v-model="model.donVi"
                    type="text"
                    class="form-control "
                    placeholder="Nhập đơn vị quản lý"
                    :class="{
                      'is-invalid':
                        submitted && $v.model.donVi.$error,
                    }"
                  />
                  <div
                      v-if="submitted && !$v.model.donVi.required"
                      class="invalid-feedback"
                  >
                    Đơn vị quản lý không được trống.
                  </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <label for="">Số điện thoại </label><span class="text-danger">*</span>
            </div>
            <div class="col-md-9">
              <div class="form-group mb-3">
                <input
                    type="text"
                    class="form-control "
                    v-model="model.soDienThoai"
                    placeholder="Nhập số điện thoại"
                    :class="{
                      'is-invalid':
                        submitted && $v.model.soDienThoai.$error,
                    }"
                  />
                  <div
                      v-if="submitted && !$v.model.soDienThoai.required"
                      class="invalid-feedback"
                  >
                    Số điện thoại không được trống.
                  </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <label for="">Địa chỉ </label><span class="text-danger">*</span>
            </div>
            <div class="col-md-9">
              <div class="form-group mb-3">
                <input
                    type="text"
                    class="form-control "
                    v-model="model.diaChi"
                    placeholder="Nhập địa chỉ"
                    :class="{
                      'is-invalid':
                        submitted && $v.model.diaChi.$error,
                    }"
                  />
                  <div
                      v-if="submitted && !$v.model.diaChi.required"
                      class="invalid-feedback"
                  >
                    Địa chỉ không được trống.
                  </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 text-center" >
              <b-button
                  class="btn bg-color btn-rounded mb-2 me-2"
                  variant="success"
                  v-on:click="handleSubmitThongTin"
              >
                <i class="bx bx-save "></i>
                Lưu thông tin
              </b-button>
            </div>
          </div>
        </form>
      </div>
    </div>

  </Layout>
</template>
<style>
.cs-edit-file{
  background: rgba(241, 102, 92, 0.1);
  padding: 0px 10px;
  border-radius: 5px;
  width: fit-content;
}
</style>
